"use client";

import dynamic from "next/dynamic";

import { BasketIcon } from "@jti/brand-icons/basket";

import styles from "./CartMini.module.scss";

const CartMiniInPlace = dynamic(
  async () => (await import("@jti/checkout/CartMiniInPlace")).CartMiniInPlace,
  {
    ssr: false,
    loading: () => <BasketIcon className={styles.icon} />,
  }
);

export const CartMini = () => {
  return (
    <div className={styles.cartMiniWrapper}>
      <CartMiniInPlace />
    </div>
  );
};
